import { render } from "./DialogEditNote.vue?vue&type=template&id=7cd5389c&scoped=true"
import script from "./DialogEditNote.vue?vue&type=script&lang=js"
export * from "./DialogEditNote.vue?vue&type=script&lang=js"

import "./DialogEditNote.vue?vue&type=style&index=0&id=7cd5389c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd5389c"]])

export default __exports__